define([
    '../Util/defined',
    '../System/Vec3Obj',
    '../Enum/EnumAltitudeMode',
], function (
    defined,
    Vec3Obj,
    EnumAltitudeMode,
) {
    'use strict';

    /**
     * 矢量面符号。
     * <br /><br />
     * <div align='center'>
     * <img src='images/PolygonSymbol.png' width='900' height='650' /><br />
     * 矢量面符号效果图
     * </div>
     * 
     * @demo {@link http://lbs.zjkelan.com/PolygonSymbol.html|CooWasm PolygonSymbol demo}
     * @alias PolygonSymbol
     * @constructor
     *
     * @param {Object} props 包含如下属性的Object：
     * @param {EnumAltitudeMode} [props.altitudeMode=EnumAltitudeMode.CLAMP] 高程模式。
     * @param {Number} [props.altitude=0.0] 高程值，单位：米。当altitudeMode为EnumAltitudeMode.CLAMP时不生效。
     * @param {Number} [props.minDistance=200.0] 最小可视距离。
     * @param {Number} [props.maxDistance=50000.0] 最大可视距离。
     * @param {ColorObj|String} [props.fillColor="#FFFFFF"] 面填充颜色，可以是ColorObj对象或十六进制颜色字符串(如"#FFFFFF")。
     * @param {Number} [props.fillAlpha=1.0] 面填充透明度，范围0.0-1.0。
     * @example
     * var icon = new CooWasm.PolygonSymbol({});
     */
    class PolygonSymbol {
        /**
         * @description 高程模式。
         * @type {EnumAltitudeMode}
         */
        altitudeMode
        /**
         * @description 高程值，单位：米。当altitudeMode为EnumAltitudeMode.CLAMP时不生效。
         * @type {Number}
         */
        altitude
        /**
         * @description 最小可视距离。
         * @type {Number}
         */
        minDistance
        /**
         * @description 最大可视距离。
         * @type {Number}
         */
        maxDistance
        /**
         * @description 面填充颜色，可以是ColorObj对象或十六进制颜色字符串(如"#FFFFFF")。
         * @type {ColorObj|String}
         */
        fillColor
        /**
         * @description 面填充透明度，范围0.0-1.0。
         * @type {Number}
         */
        fillAlpha
        /**
         * @description 属性信息。
         * @private
         * @readonly
         */
        properties = ""
        /**
         * @description PolygonSymbol在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "PolygonSymbol"

        constructor(props) {
            if (!defined(props)) {
                props = {}
            }
            this.properties += this.toStr("altitudeMode", props.altitudeMode, "AltitudeMode")
            this.properties += this.toStr("altitude", props.altitude, "Altitude")
            this.properties += this.toStr("minDistance", props.minDistance, "MinVisibleDistance")
            this.properties += this.toStr("maxDistance", props.maxDistance, "MaxVisibleDistance")
            this.properties += this.toStr("fillColor", props.fillColor, "FillColor")
            this.properties += this.toStr("fillAlpha", props.fillAlpha, "FillTransparency")
        }

        toStr(memName, value, key) {
            let result = ""
            if (defined(value)) {
                this[memName] = value
                if (typeof value.toStr === 'function') {
                    result = key + ":" + value.toStr() + "|"
                } else {
                    result = key + ":" + value + "|"
                }
            }
            return result
        }
        
        update(symbol) {
            let componentProps = ""
            if (!defined(symbol)) {
                return componentProps
            }
            if (defined(symbol.altitudeMode)) {
                this.altitudeMode = symbol.altitudeMode
                componentProps += "AltitudeMode:" + this.altitudeMode + "|"
            }
            if (defined(symbol.altitude)) {
                this.altitude = symbol.altitude
                componentProps += "Altitude:" + this.altitude + "|"
            }
            if (defined(symbol.minDistance)) {
                this.minDistance = symbol.minDistance
                componentProps += "MinVisibleDistance:" + this.minDistance + "|"
            }
            if (defined(symbol.maxDistance)) {
                this.maxDistance = symbol.maxDistance
                componentProps += "MaxVisibleDistance:" + this.maxDistance + "|"
            }
            if (defined(symbol.fillColor)) {
                this.fillColor = symbol.fillColor
                componentProps += "FillColor:" + this.fillColor + "|"
            }
            if (defined(symbol.fillAlpha)) {
                this.fillAlpha = symbol.fillAlpha
                componentProps += "FillTransparency:" + this.fillAlpha + "|"
            }
            return componentProps
        }
    }
    return PolygonSymbol
})